import { Workflow } from '@/types/workflow-types';
import { apiRequest } from '@/utils/api-request';

export interface DuplicateWorkflowResponse {
  data?: {
    workflow?: Workflow;
    success?: boolean;
    message?: string;
  };
  message?: string;
  detail?: string;
}

/**
 * POSTs to duplicate workflow or to create template from a workflow
 * when duplicate a workflow, presign url of file nodes, if any,
 * will be paired with new duplicated workflow id
 * @param wIdToDuplicate Workflow ID to duplicate
 * @param orgId Organization ID
 * @param newName New name for the duplicated workflow
 * @param newDescription New description for the duplicated workflow
 * @param isTemplate Whether to create a template from the duplicated workflow
 * @returns Backend response JSON
 */
export async function duplicateWorkflow(
  wIdToDuplicate: string,
  orgId: string,
  newName: string,
  newDescription: string,
  isTemplate: boolean,
  icon?: string | null,
  color?: string | null,
  bgColor?: string | null,
) {
  // Convert payload to the format expected by apiRequest
  const payload = {
    workflow_id: wIdToDuplicate,
    name: newName,
    description: newDescription,
    publish_to_template: isTemplate,
    icon,
    color,
    bg_color: bgColor,
  };

  const response = await apiRequest<DuplicateWorkflowResponse>({
    url: `/api/v1/orgs/${orgId}/workflows/duplicate`,
    method: 'POST',
    target: 'workflow',
    body: payload,
  });

  if (response?.detail) {
    return {
      detail: response.detail || 'Failed to update workflow',
    };
  }
  return response;
}
